/**
 * PersonFullName
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectPersonValue } from '../../services/people/selectors';

export class PersonFullName extends React.PureComponent {
    render() {
        return this.props.fullName;
    }
}

PersonFullName.propTypes = {
    fullName: PropTypes.string
};

PersonFullName.defaultProps = {
    fullName: null
};

const mapStateToProps = createStructuredSelector({
    fullName: makeSelectPersonValue('_fullName')
});

export default connect(mapStateToProps)(PersonFullName);
